import { Globe2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { normalizeLanguage, SUPPORTED_LANGUAGES, type SupportedLanguage } from "../i18n/language";

const LABELS: Record<SupportedLanguage, string> = {
  en: "EN",
  "zh-CN": "中文",
  ja: "日本語",
  ko: "한국어",
  es: "ES",
};

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);

  const changeLanguage = async (language: string) => {
    await i18n.changeLanguage(language);
    const url = new URL(window.location.href);
    url.searchParams.set("lang", language);
    window.history.replaceState(window.history.state, "", url);
  };

  return (
    <label className="language-switcher" title={t("common.language")}>
      <Globe2 size={16} />
      <select value={current} onChange={(event) => void changeLanguage(event.target.value)} aria-label={t("common.language")}>
        {SUPPORTED_LANGUAGES.map((language) => <option key={language} value={language}>{LABELS[language]}</option>)}
      </select>
    </label>
  );
}
